import {
  InformationSectionSubtitleContent,
  InformationSectionTextContent,
  List,
  ListItem,
  ListItemText,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type FacilityNote } from "@src/appV2/Facilities/types";

interface LateClockOutSectionProps {
  lateClockOutNote: FacilityNote;
}

export function LateClockOutSection(props: LateClockOutSectionProps) {
  const { lateClockOutNote } = props;

  return (
    <List dense>
      <ListItem>
        <ListItemText
          disableTypography
          primary={
            <InformationSectionSubtitleContent>Workplace policy:</InformationSectionSubtitleContent>
          }
          secondary={
            <InformationSectionTextContent>{lateClockOutNote.note}</InformationSectionTextContent>
          }
        />
      </ListItem>

      <ListItem>
        <ListItemText
          disableTypography
          primary={
            <InformationSectionSubtitleContent>
              Fill out shift extension form
            </InformationSectionSubtitleContent>
          }
          secondary={
            <Stack spacing={2}>
              <InformationSectionTextContent>
                Complete the shift extension form before clocking out. The form will be available in
                the app after your scheduled shift end time.
              </InformationSectionTextContent>
            </Stack>
          }
        />
      </ListItem>
    </List>
  );
}
